import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";

// Local icons for tags
import AccessibilityIcon from "../Asset/Images/Dimensions/Accessibility.jpg";
import AchievementIcon from "../Asset/Images/Dimensions/Achievement.jpg";
import CommunityIcon from "../Asset/Images/Dimensions/Community.jpg";
import EducationIcon from "../Asset/Images/Dimensions/Education.jpg";
import GrowthIcon from "../Asset/Images/Dimensions/Growth.jpg";
import HealthIcon from "../Asset/Images/Dimensions/Health.jpg";
import KnowledgeIcon from "../Asset/Images/Dimensions/Knowledge.jpg";
import Environment from "../Asset/Images/Dimensions/Environment.jpg";

import PortfolioCard from "./PortfolioCard";
import theme from "../theme";
import { getPortfolio } from "../Api/ForPortfolio";

// Tag to icon map
const tagIcons = {
  GROWTH: GrowthIcon,
  KNOWLEDGE: KnowledgeIcon,
  ACHIEVEMENT: AchievementIcon,
  ACCESSIBILITY: AccessibilityIcon,
  COMMUNITY: CommunityIcon,
  HEALTH: HealthIcon,
  EDUCATION: EducationIcon,
  ENVIRONMENT: Environment, // fixed typo
};

const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState([]);

  useEffect(() => {
    getPortfolio().then((res) => {
      if (!res?.items) return;

      // Create asset map for all images
      const assetMap = {};
      res.includes?.Asset?.forEach((asset) => {
        assetMap[asset.sys.id] = `https:${asset.fields.file.url}`;
      });

      // Map API data to card props
      // Map API data to card props
      const mappedData = res.items.map((item) => {
        const name = item.fields.companyName || "";
        const tags = item.fields.tags || [];

        // Tag icons
        const dimensionIcons = tags
          .map((tag) => tagIcons[tag.toUpperCase()] || null)
          .filter(Boolean);

        // Leadership faces (always array)
        const faces = Array.isArray(item.fields.leadership)
          ? item.fields.leadership
              .map((leader) => assetMap[leader.sys.id] || null)
              .filter(Boolean)
          : [];

        return {
          name,
          logo: item.fields.companyLogo?.sys?.id
            ? assetMap[item.fields.companyLogo.sys.id]
            : "",
          description: item.fields.description || "",
          url: item.fields.website || "",
          dimensions: Array.isArray(dimensionIcons) ? dimensionIcons : [],
          faces, // guaranteed to be []
          status: "active",
        };
      });

      // ✅ Sort alphabetically by company name
      mappedData.sort((a, b) => a.name.localeCompare(b.name));

      setPortfolioData(mappedData);
    });
  }, []);

  return (
    <Box
      id="Portfolio"
      sx={{
        my: { xs: 5, sm: 5, md: 10 },
        display: "flex",
        flexDirection: "column",
        px: { xs: 0, sm: 5, md: 5 },
        maxWidth: "1050px",
        mx: "auto",
      }}
    >
      <Typography
        variant="h4"
        align="center"
        sx={{
          fontWeight: 600,
          letterSpacing: 1,
          fontFamily: theme.fonts.secondary,
          color: theme.palette.primary.main,
          mb:4
        }}
      >
        Portfolio
      </Typography>

      <Grid container spacing={2}>
        {portfolioData.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 2,
            }}
          >
            <PortfolioCard item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Portfolio;
